module.exports = __webpack_public_path__ + "static/media/timeline.3a369c34.svg";